import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import {
    catchError,
    concatMap,
    endWith,
    flatMap,
    map,
    mergeAll,
    mergeMap,
    startWith,
    switchMap,
    take
} from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Với từng function, nhận 2 stream là action$ và state$ => dùng pipe() để nối các operator lại. Lấy type của action gửi lên server => gửi api => nhận data => trả về action set của reducer
const postVehicleList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.MAINTAINANCE_REPORT.POST_VEHICLE_LIST),
        mergeMap((action) => {
            const api = async () => {
                const vehiclesList = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.MAINTAINANCE_REPORT.POST_VEHICLE_LIST,
                    { ...action.payload }
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_VEHICLE_LIST, {
                        data: vehiclesList.data.data
                    })
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getMaintainanceWorks = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.MAINTAINANCE_REPORT.GET_MAINTAINANCE_WORKS),
        mergeMap((action) => {
            const api = async () => {
                const maintainanceWorks = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.MAINTAINANCE_REPORT.GET_MAINTAINANCE_WORKS,
                    { ...action.payload }
                )

                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_MAINTAINANCE_WORKS, {
                        data: maintainanceWorks.data.data
                    })
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getVendorSupplies = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.MAINTAINANCE_REPORT.GET_VENDOR_SUPPLIES),
        mergeMap((action) => {
            const api = async () => {
                const vendorSupplies = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.MAINTAINANCE_REPORT.GET_VENDOR_SUPPLIES,
                    { ...action.payload }
                )

                let arrayAction = []

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_VENDOR_SUPPLIES, {
                        data: vendorSupplies.data.data
                    })
                )

                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postReportDataAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.MAINTAINANCE_REPORT.POST_REPORT_DATA_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const reportData = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.MAINTAINANCE_REPORT.POST_REPORT_DATA_ACTION,
                    { ...action.payload }
                    )

                let arrayAction = []

                reportData.data.status
                    ? arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              "Tải dữ liệu thành công"
                          )
                      )
                    : arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              Array.isArray(reportData.data.data) && reportData.data.data.length === 0
                                  ? "Không có dữ liệu báo cáo"
                                  : "Lỗi trong lúc tải dữ liệu"
                          )
                      )
                      
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_REPORT_DATA_ACTION,
                        reportData.data.data
                    )
                )

                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postDownloadReportAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.MAINTAINANCE_REPORT.POST_DOWNLOAD_REPORT_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const downloadReport = await CONSTANTS.FUNCTION.AXIOS.POST_DOWNLOAD_FILE(
                    CONSTANTS.URL.MAINTAINANCE_REPORT.POST_DOWNLOAD_REPORT_ACTION,
                    { ...action.payload }
                )

                let arrayAction = []

                if (downloadReport.status !== 200 || downloadReport.statusText !== "OK") {
                    arrayAction.push(
                        CONSTANTS.FUNCTION.REDUX.DISPATCH(
                            CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                            "Lỗi trong lúc tải dữ liệu"
                        )
                    )
                    return arrayAction
                }

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.MAINTAINANCE_REPORT.SET_DOWNLOAD_REPORT_ACTION,
                        downloadReport.data
                    )
                )

                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

export default {
    postVehicleList,
    getMaintainanceWorks,
    getVendorSupplies,
    postReportDataAction,
    postDownloadReportAction
}
